module.exports = __webpack_public_path__ + "static/media/carl987-100.71d21414.jpg";